import React, { useState, useEffect } from "react";
import moment from "moment";
import toast from "react-hot-toast";
import busyTimeApi from "../../api/staff/busyTimeApi";

const durationOptions = [30, 60, 90, 120, 180, 240]; // in minutes

const AddBusyTimeModal = ({ isOpen, onClose, staffId, start, onSuccess }) => {
  const [note, setNote] = useState("");
  const [duration, setDuration] = useState(60); // default 1 hour
  const [endTime, setEndTime] = useState(null);

  useEffect(() => {
    if (start && duration) {
      const end = moment(start).add(duration, "minutes").toDate();
      setEndTime(end);
    }
  }, [start, duration]);

  const handleSubmit = async () => {
    try {
      const payload = {
        staff: staffId,
        date: moment(start).format("YYYY-MM-DD"),
        start: moment(start).format("hh:mm A"),
        end: moment(endTime).format("hh:mm A"),
        reason: note || "Busy",
      };

      const { response, err } = await busyTimeApi.createBusyTime(payload);
      if (response) {
        toast.success("Busy time added");
        onSuccess?.(); // reload bookings if needed
        onClose();
      } else {
        toast.error(err?.response?.data?.message || "Failed to add busy time");
      }
    } catch (err) {
      console.error("Busy time submit error:", err);
      toast.error("Something went wrong");
    }
  };

  if (!isOpen || !start) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg w-[90%] max-w-md shadow-xl">
        <h2 className="text-xl font-bold mb-4">Add Busy Time</h2>

        <div className="text-sm text-gray-700 mb-3">
          <p>
            <span className="font-semibold">Start:</span>{" "}
            {moment(start).format("hh:mm A")}
          </p>
          <p>
            <span className="font-semibold">End:</span>{" "}
            {moment(endTime).format("hh:mm A")}
          </p>
        </div>

        <label className="block text-sm mb-2 font-medium">Duration</label>
        <select
          className="w-full border rounded px-3 py-2 mb-4"
          value={duration}
          onChange={(e) => setDuration(Number(e.target.value))}
        >
          {durationOptions.map((mins) => (
            <option key={mins} value={mins}>
              {mins / 60 >= 1
                ? `${mins / 60} hr${mins > 60 ? "s" : ""}`
                : `${mins} mins`}
            </option>
          ))}
        </select>

        <label className="block text-sm mb-2 font-medium">
          Note (optional)
        </label>
        <textarea
          rows={3}
          className="w-full border rounded px-3 py-2 mb-4 text-sm"
          placeholder="Add a note (e.g. Lunch, Emergency...)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />

        <div className="flex justify-end gap-2">
          <button
            className="px-4 py-2 rounded bg-gray-200 text-sm"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 rounded bg-yellowlight text-white text-sm"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddBusyTimeModal;
